import { OptionalRailEuropeTrainQueryParam, RailEuropeTrainQueryParam } from '~types/queryParam';

export default function getValidQueryString<P extends RailEuropeTrainQueryParam>(
  query?: Record<string, unknown> | OptionalRailEuropeTrainQueryParam,
): P {
  const {
    category,
    journey,
    origin,
    destination,
    departureDate,
    arrivalDate,
    outboundDepartureTime,
    inboundDepartureTime,
    ages,
    outboundOfferId,
  } = (query || {}) as OptionalRailEuropeTrainQueryParam;

  const utmQueries = Object.fromEntries(
    Object.entries(query || {}).filter(([key]) => key.startsWith('utm_')),
  );

  return {
    category,
    journey,
    origin,
    destination,
    departureDate,
    arrivalDate,
    outboundDepartureTime,
    inboundDepartureTime,
    ages,
    outboundOfferId,
    ...utmQueries,
  } as P;
}
